import { Routes, Route, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './print.css';
import LoginPage from "./pages/LoginPage";
import SessionExpired from "./pages/SessionExpired";
import Ebook from "./pages/Ebook";
import Managebook from "./pages/Managebook";
import ViewBook from "./pages/ViewBook";
import AdminUsers from "./pages/AdminUsers";
import Readers from "./pages/Readers";
import Settings from "./pages/Settings";
import Home from "./pages/Home";
import DailyQuotes from "./pages/DailyQuotes";
import Notifications from "./pages/Notifications";

import useAuthStore from "./store/authStore";
import useLoadingStore from "./store/loadingStore";
import useAuthSync from "./hooks/useAuthSync";

import Loader from "./components/Loader";
import ProtectedRoute from "./utils/ProtectedRoute";
import DashboardLayout from "./layout/DashboardLayout"; 
import ManagEbook from "./pages/ManageEbook";
import BookDetails from "./pages/BookDetails";
import EditorPreview from "./pages/EditorPreview";
import FileManager from "./pages/FileManager";

function App() {
  const isLoading = useLoadingStore((state) => state.isLoading);
  const { initializeAuth, logout, isLoggingOut } = useAuthStore();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoggingOut) {
      initializeAuth();
    }

    const syncLogout = (e) => {
      if (e.key === "token" && !e.newValue) {
        logout();
        navigate("/login");
      }
    };

    window.addEventListener("storage", syncLogout);
    return () => window.removeEventListener("storage", syncLogout);
  }, [initializeAuth, logout, isLoggingOut, navigate]);

  useAuthSync();

  return (
    <div>
      <ToastContainer />
      {isLoading && <Loader />}
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/session-expired" element={<SessionExpired />} />
        
        <Route element={<ProtectedRoute />}>
          <Route element={<DashboardLayout />}>
            <Route path="/dashboard/home" element={<Home />} />
            <Route path="/dashboard/ebooks" element={<Ebook />} />
            <Route path="/dashboard/dailyquotes" element={<DailyQuotes />} />
            <Route path="/dashboard/adminusers" element={<AdminUsers />} />
            <Route path="/dashboard/readers" element={<Readers />} />
            <Route path="/dashboard/filemanager" element={<FileManager />} />
            <Route path="/dashboard/settings" element={<Settings />} />
          </Route>
          <Route path="/managebook" element={<Managebook />} />
          <Route path="/bookdetails" element={<BookDetails />} />
           <Route path="/view-book/:id" element={<ViewBook />} />
         
        </Route>
         <Route path="/editor-preview" element={<EditorPreview />} />

        {/* Default route */}
        <Route path="/" element={<LoginPage />} />
      </Routes>
    </div>
  );
}

export default App;
